import { Image } from 'expo-image';
import { DimensionValue, Platform, StyleSheet, View } from 'react-native';

const DEFAULT_BACKGROUND_HEIGHT = 187;
const DEFAULT_IMAGE_HEIGHT = '100%';
const DEFAULT_REPEAT_INTERVAL = 14;

type BackgroundProps = {
  backgroundHeight?: number;
  imageHeight?: DimensionValue;
  repeat?: number;
};

export const Background = ({
  backgroundHeight = DEFAULT_BACKGROUND_HEIGHT,
  imageHeight = DEFAULT_IMAGE_HEIGHT,
  repeat = DEFAULT_REPEAT_INTERVAL,
}: BackgroundProps) => {
  return (
    <View
      accessible={false}
      accessibilityElementsHidden
      importantForAccessibility="no"
      {...(Platform.OS === 'web' ? ({ 'aria-hidden': true } as const) : {})}
      style={[
        styles.trayPatternContainer,
        {
          height: backgroundHeight,
        },
      ]}
    >
      {[...Array(repeat)].map((_, i) => {
        return (
          <Image
            key={i}
            accessibilityLabel="Decorative tray pattern"
            alt="Decorative tray pattern"
            accessibilityRole="none"
            accessible={false}
            source={require('./tray-pattern.webp')}
            placeholder={{ thumbhash: '+wcCB4DHxneIZ3hXR5eGeXhwhkCH93wH' }}
            style={[styles.backgroundPattern, { height: imageHeight }]}
            contentFit="cover"
          />
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  backgroundPattern: {
    aspectRatio: 751 / 706,
  },
  trayPatternContainer: {
    overflow: 'hidden',
    flexDirection: 'row',
  },
});
